import React, { useEffect, useState } from "react";

interface MemberCodeGroupDisplayProps {
    utility?: Utility[]
    profit?: ProfitCenter[]
    call?: CallCenter[]
}
interface Utility {
    UtilityName: string,
    UtilityID: number
}
interface ProfitCenter {
    ProfitCenter: string,
    ProfitCenterID: number
}
interface CallCenter {
    CallCenterName: string,
    CallCenterID: number
}
function MemberCodeGroupDisplay(props: MemberCodeGroupDisplayProps) {
    const [utility, setUtility] = useState<Utility[]>()
    const [profit, setProfit] = useState<ProfitCenter[]>()
    const [call, setCall] = useState<CallCenter[]>()
    const [viewAll, setViewAll] = useState(false)
    //r-18-lint-cn
    //eslint-disable-next-line
    useEffect(() => {
        if (props.utility) {
            setUtility(props.utility)
        }
        if (props.call) {
            setCall(props.call)
        }
        if (props.profit) {
            setProfit(props.profit)
        }
    })
    return (
        <td className="memberExpamdable">
            {
                utility ?
                    <>
                        {
                            utility.map((x, index) => (
                                index < 2 && !viewAll ?
                                    `${x.UtilityName} (${x.UtilityID}); `
                                    : viewAll ?
                                        `${x.UtilityName} (${x.UtilityID}); `
                                        : null
                            ))
                        }
                        {
                            utility.length > 2 && !viewAll ?
                                //r-18-lint-cn
                                //eslint-disable-next-line
                                <b onClick={(e) => (setViewAll(true), e.stopPropagation())}>{`+ ${utility.length - 2} more`}</b> :
                                viewAll ?
                                    //r-18-lint-cn
                                    //eslint-disable-next-line
                                    <b onClick={(e) => (setViewAll(false), e.stopPropagation())}>less</b> :
                                    null
                        }
                    </> :
                    call ?
                        <>
                            {
                                call.map((x, index) => (
                                    index < 2 && !viewAll ?
                                        `${x.CallCenterName} (${x.CallCenterID}); ` :
                                        viewAll ?
                                            `${x.CallCenterName} (${x.CallCenterID}); ` :
                                            null
                                ))
                            }
                            {
                                call.length > 2 && !viewAll ?
                                    //r-18-lint-cn
                                    //eslint-disable-next-line
                                    <b onClick={(e) => (setViewAll(true), e.stopPropagation())}>{`+ ${call.length - 2} more`}</b> :
                                    viewAll ?
                                        //r-18-lint-cn
                                        //eslint-disable-next-line
                                        <b onClick={(e) => (setViewAll(false), e.stopPropagation())}>less</b> :
                                        null
                            }
                        </> :
                        profit ?
                            <>
                                {
                                    profit.map((x, index) => (
                                        index < 2 && !viewAll ?
                                            `${x.ProfitCenter} (${x.ProfitCenterID}); ` :
                                            viewAll ?
                                                `${x.ProfitCenter} (${x.ProfitCenterID}); ` :
                                                null
                                    ))
                                }
                                {
                                    profit.length > 2 && !viewAll ?
                                        //r-18-lint-cn
                                        //eslint-disable-next-line
                                        <b onClick={(e) => (setViewAll(true), e.stopPropagation())}>{`+ ${profit.length - 2} more`}</b> :
                                        viewAll ?
                                            //r-18-lint-cn
                                            //eslint-disable-next-line
                                            <b onClick={(e) => (setViewAll(false), e.stopPropagation())}>less</b> :
                                            null
                                }
                            </> :
                            null
            }

        </td>
    )
}

export default MemberCodeGroupDisplay